/* Nische wishlist - localStorage only, no app, no account required.
   Saves product handles per browser. Every card heart on the page reflects
   the same state instantly, and the wishlist page rerenders with no reload. */
(function () {
  'use strict';

  /* A page with two card sections (the homepage has two featured collections)
     emits this script once per section, so it executes more than once. Without
     this guard every extra run adds another delegated click listener and each
     tap toggles the heart twice - saving then instantly un-saving, which looks
     exactly like nothing happening. Bail out if we are already set up. */
  if (window.NischeWishlist) return;

  var KEY = 'nische:wishlist';
  var EVENT = 'nische:wishlist:change';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      /* private mode, blocked storage, corrupt value - behave as empty */
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable: the page still works, it just will not persist */
    }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) {
      list.unshift(handle);
    } else {
      list.splice(i, 1);
    }
    write(list);
    announce(handle, i === -1);
    return i === -1;
  }

  function remove(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) return false;
    list.splice(i, 1);
    write(list);
    announce(handle, false);
    return true;
  }

  function announce(handle, added) {
    syncButtons();
    syncCounts();
    document.dispatchEvent(
      new CustomEvent(EVENT, { detail: { handle: handle, added: added, list: read() } })
    );
  }

  /* Reflect stored state onto every heart currently in the DOM. */
  function syncButtons(root) {
    var scope = root || document;
    var list = read();
    scope.querySelectorAll('[data-nc-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-nc-wish')) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? btn.dataset.labelOn : btn.dataset.labelOff;
      if (label) btn.setAttribute('aria-label', label);
    });
  }

  function syncCounts() {
    var n = read().length;
    document.querySelectorAll('[data-nc-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  /* One delegated listener covers cards injected later (wishlist page,
     paginated grids, section rendering) without rebinding. */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-nc-wish]');
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();

    var handle = btn.getAttribute('data-nc-wish');
    if (!handle) return;

    var added = toggle(handle);

    /* Restart the animation even on a rapid second tap. */
    btn.classList.remove('nc-wish--pop', 'nc-wish--off');
    void btn.offsetWidth;
    btn.classList.add(added ? 'nc-wish--pop' : 'nc-wish--off');
  });

  /* Another tab changed the list - keep this one honest. */
  window.addEventListener('storage', function (evt) {
    if (evt.key === KEY) {
      syncButtons();
      syncCounts();
    }
  });

  function init() {
    syncButtons();
    syncCounts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.NischeWishlist = {
    key: KEY,
    event: EVENT,
    read: read,
    has: has,
    toggle: toggle,
    remove: remove,
    count: function () { return read().length; },
    hydrate: function (root) { syncButtons(root); syncCounts(); }
  };
})();
